import { Instance, types } from "mobx-state-tree";
import { IMessageWidgetConfig, MessageWidgetConfig } from "./MessageWidgetConfig";

export const NO_TAG_GROUP_ID = "no_tag_id";

export const TagGroupMessageWidgetsMap = types
  .model("TagGroupMessageWidgetsMap", {
    tagGroupId: types.identifier,
    configs: types.array(MessageWidgetConfig)
  })
  .actions((self) => {
    const actions = {
      setConfigs(configs: IMessageWidgetConfig[]) {
        self.configs.replace(configs);
      }
    };

    return actions;
  });

export interface ITagGroupMessageWidgetsMap extends Instance<typeof TagGroupMessageWidgetsMap> {}
